import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=342698e2"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports